































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TedsAdministratorLogo extends Vue {}
